import { Gebaeudeschaeden, Kunde, SelectOption } from '@gsm/entities';
import { DynamicFormControlLayout, DynamicFormValueControlModel, DynamicFormValueControlModelConfig, serializable } from '@ng-dynamic-forms/core';

export const TYPE_GEBAEUDE_SCHADEN = 'GEBAEUDE_SCHADEN';

interface GebaeudeSchadenAdditional extends Record<string, any> {
  docTypEigenleistung?: SelectOption[];
  docTypFachfirma?: SelectOption[];
  gewerkeList?: SelectOption[];
  kundeList?: Kunde[];
  schadenhoeheList?: SelectOption[];
}

export interface GebaeudeSchadenModelConfig extends DynamicFormValueControlModelConfig<Gebaeudeschaeden> {
  additional: GebaeudeSchadenAdditional;
}

export class GebaeudeSchadenModel extends DynamicFormValueControlModel<Gebaeudeschaeden> {
  @serializable() readonly type: string = TYPE_GEBAEUDE_SCHADEN;

  constructor(config: GebaeudeSchadenModelConfig, layout?: DynamicFormControlLayout) {
    super(config, layout);
  }
}
